import type { ComponentPropsWithoutRef } from "react";
import { cx } from "@/utils/cx";

export type PageSurfaceProps = ComponentPropsWithoutRef<"div">;

/**
 * Superfície principal das telas autenticadas elegíveis.
 *
 * Usa `bg-secondary` e a classe `page-surface`. Em `globals.css`, a combinação
 * das duas classes resolve o fundo deste elemento para `gray-100` (#F5F5F5).
 * O token `--color-bg-secondary` continua valendo `gray-50` (#FAFAFA) para os
 * descendentes, então cabeçalhos de tabela, hovers, cards e filtros mantêm a
 * aparência atual.
 *
 * Não renderiza `main`: o layout autenticado já fornece esse landmark.
 */
export function PageSurface({
	className,
	children,
	...props
}: PageSurfaceProps) {
	return (
		<div
			className={cx("page-surface w-full bg-secondary", className)}
			data-slot="page-surface"
			{...props}
		>
			{children}
		</div>
	);
}
